import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MassiveEditEvaluationActions } from './massive-edit-evaluation.actions';
import { EvaluationTreeService } from '../../service/evaluationTree.service';


@Injectable()
export class MassiveEditEvaluationEffects {

  loadEvaluationTree$ = createEffect(
    (rs: EvaluationTreeService = inject(EvaluationTreeService)) => {
      return this.actions$.pipe(

        ofType(MassiveEditEvaluationActions.loadEvaluationTree),
        mergeMap(({ campaignId, legalEntityId, parameters, fields, au }) =>
          rs.getEvaluationTree(campaignId, legalEntityId, parameters, au, null).pipe(
            map((evaluation) => {
              return MassiveEditEvaluationActions.loadEvaluationTreeSuccess({
                evaluation,
                fields
              });
            }),
            catchError((error) => of(MassiveEditEvaluationActions.loadEvaluationTreeFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadAllEvaluationTree$ = createEffect(
    (rs: EvaluationTreeService = inject(EvaluationTreeService)) => {
      return this.actions$.pipe(
        ofType(MassiveEditEvaluationActions.loadAllEvaluationTree),
        mergeMap(({ campaignId, legalEntityId, fields }) =>
          rs.getAllEvaluationTree(campaignId, legalEntityId).pipe(
            mergeMap((evaluation) => {
              const successAction = MassiveEditEvaluationActions.loadAllEvaluationTreeSuccess({
                evaluation,
                fields
              });

              // const anotherAction = MassiveEditEvaluationActions.loadEvaluationTree({
              //   au,
              //   campaignId,
              //   legalEntityId,
              //   parameters: param,
              //   fields,
              //   completed
              // });

              return [successAction];
            }),
            catchError((error) =>
              of(MassiveEditEvaluationActions.loadAllEvaluationTreeFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );


  constructor(private actions$: Actions) { }
}
